/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FirePlaidSandboxItemWebhookRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/testing/FirePlaidSandboxItemWebhook.pb'
import {FirePlaidSandboxItemWebhookResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/testing/FirePlaidSandboxItemWebhook.pb'


export const firePlaidSandboxItemWebhook = (request:FirePlaidSandboxItemWebhookRequest, options?: CashRequestOptions) => post<FirePlaidSandboxItemWebhookRequest, FirePlaidSandboxItemWebhookResponse>("/2.0/cash/fire-plaid-sandbox-item-webhook", request, {...options, rejectOnError: true })